module.exports = __webpack_public_path__ + "img/745.aeed0a03.png";